module.exports = __webpack_public_path__ + "static/media/icn_ongoing_trtmnt_covid_myway.eb9ad6a6.svg";